import ApplicableIcon from '@/assets/applicable.svg?react';
import NotApplicableIcon from '@/assets/not_applicable.svg?react';
import { cn } from '@/utils/classUtils';
import { Archive, CircleDashed } from 'lucide-react';
import { type FC } from 'react';

export type StatusTab =
  | 'to_review'
  | 'applicable'
  | 'not_applicable'
  | 'out_of_scope';

export const STATUS_TAB_LABELS: Record<StatusTab, string> = {
  to_review: 'To review',
  applicable: 'Applicable',
  not_applicable: 'Not applicable',
  out_of_scope: 'Out of scope',
};

const TABS: {
  value: StatusTab;
  label: string;
  icon: FC<{ className?: string }>;
}[] = [
  {
    value: 'to_review',
    label: STATUS_TAB_LABELS.to_review,
    icon: CircleDashed,
  },
  {
    value: 'applicable',
    label: STATUS_TAB_LABELS.applicable,
    icon: ApplicableIcon,
  },
  {
    value: 'not_applicable',
    label: STATUS_TAB_LABELS.not_applicable,
    icon: NotApplicableIcon,
  },
  {
    value: 'out_of_scope',
    label: STATUS_TAB_LABELS.out_of_scope,
    icon: Archive,
  },
];

export const StatusTabs: FC<{
  activeTab: StatusTab;
  onTabChange: (tab: StatusTab) => void;
  /** Unread count for to_review only (must match card "new" / future footer). */
  toReviewUnreadCount: number;
}> = ({ activeTab, onTabChange, toReviewUnreadCount }) => {
  return (
    <div className="flex justify-center w-full">
      <div className="inline-flex items-center rounded-xl bg-neutral-100 p-1">
        {TABS.map(tab => {
          const isActive = activeTab === tab.value;
          const Icon = tab.icon;
          const isToReview = tab.value === 'to_review';

          return (
            <button
              key={tab.value}
              className={cn(
                'flex items-center gap-2 rounded-[10px] min-h-[32px] min-w-[32px] px-2.5 py-[5.5px] text-sm font-medium tracking-[0.07px] transition-all whitespace-nowrap',
                isActive
                  ? 'bg-white text-neutral-900'
                  : 'text-neutral-900 hover:bg-white/50'
              )}
              onClick={() => onTabChange(tab.value)}
            >
              <Icon className="h-5 w-5 shrink-0" />
              {tab.label}
              {isToReview && (
                <span className="inline-flex items-center justify-center rounded-[10px] min-w-[16px] h-4 px-1 text-xs font-medium leading-none bg-yellow-400 text-neutral-900 shadow-[0_0_0_2px_#ffe228]">
                  {toReviewUnreadCount}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
